module.exports = __webpack_public_path__ + "img/img-service.34d30f05.png";